import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { SITE, img, openEnquiry } from "../config";
import { AMENITIES, AMENITY_LIST } from "../data/site";

const TITLE = "Atlanta Enclave Amenities | Shilphata";
const DESC =
    "Atlanta Enclave amenities in Shilphata, Thane – clubhouse, swimming pool, gym, kids' play area, yoga room, EV charging & 24/7 security in an 8-acre gated community.";

const JSON_LD = [
    {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: TITLE,
        url: "https://atlantaenclave.com/amenities/",
        description: DESC,
        isPartOf: { "@type": "WebSite", name: "Atlanta Enclave", url: "https://atlantaenclave.com/" },
    },
];

export default function Amenities() {
    return (
        <div data-testid="amenities-page">
            <Seo title={TITLE} description={DESC} path="/amenities/" jsonLd={JSON_LD} />
            <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Amenities" }]} />

            <section className="container-x mt-8">
                <Reveal>
                    <p className="eyebrow">8-Acre Gated Community</p>
                    <h1 className="font-display mt-3 max-w-3xl text-4xl font-medium leading-[1.1] text-[#23231f] sm:text-5xl">
                        Atlanta Enclave Amenities — Shilphata
                    </h1>
                    <p className="mt-5 max-w-2xl text-sm leading-relaxed text-[#55534a] sm:text-base">
                        Whether it&apos;s a dip in the swimming pool, a stroll through lush landscaped gardens or a workout in
                        the state-of-the-art fitness center — Atlanta Enclave Shilphata offers a range of recreational
                        experiences to rejuvenate your body and mind, within a secure, gated community.
                    </p>
                </Reveal>

                <div className="mt-10 grid grid-cols-2 gap-5 lg:grid-cols-4">
                    {AMENITIES.map((a, i) => (
                        <Reveal key={a.name} delay={(i % 4) * 70}>
                            <figure className="card-line p-3" data-testid={`amenity-${a.image}`}>
                                <img src={img(a.image)} alt={a.alt} className="aspect-square w-full object-cover" loading="lazy" width="236" height="236" />
                                <figcaption className="p-2">
                                    <p className="text-sm font-bold text-[#23231f]">{a.name}</p>
                                    <p className="mt-1 text-xs leading-relaxed text-[#55534a]">{a.desc}</p>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>

                <Reveal className="mt-10">
                    <h2 className="font-display text-2xl font-semibold text-[#23231f]">Complete Amenities List</h2>
                    <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
                        {AMENITY_LIST.map((a) => (
                            <li key={a} className="flex items-center gap-2.5 border-b border-[#ded8c6] pb-2 text-sm text-[#23231f]">
                                <span className="h-1.5 w-1.5 rounded-full bg-[#8f7f45]" /> {a}
                            </li>
                        ))}
                    </ul>
                </Reveal>

                <Reveal className="mt-10">
                    <div className="card-line flex flex-col items-start justify-between gap-5 p-6 sm:flex-row sm:items-center sm:p-8">
                        <div>
                            <h2 className="font-display text-2xl font-semibold text-[#23231f]">Experience It in Person</h2>
                            <p className="mt-2 max-w-xl text-sm text-[#55534a]">
                                Book a site visit to experience the amenities at Atlanta Enclave Shilphata first-hand. Call{" "}
                                {SITE.phoneDisplay}.
                            </p>
                        </div>
                        <button onClick={openEnquiry} className="btn btn-gold" data-testid="amenities-enquire-button">
                            Book Site Visit
                        </button>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
